import { render, staticRenderFns } from "./MagicIcon.vue?vue&type=template&id=dc3d3670&"
import script from "./MagicIcon.vue?vue&type=script&lang=js&"
export * from "./MagicIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports